import usePartner from '../../hooks/usePartner'
import buildComponent from './buildComponent'

export default function PartnerComponent({ id, config, promoNames, ...props }) {
  if (!config && id) {
    config = usePartner(`config.scaffolding.${id}`)
  }

  if (!promoNames) {
    promoNames = usePartner('promoService.promoNames')
  }

  return !config
    ? null
    : buildComponent(config.component, config.props, config.renderConditions, props, id, promoNames)
}
